import { Dashboard, AddArticle } from '../../routes/'

export const rootLinks = [
    {
        path: '',
        name: 'All articles',
        component: Dashboard,
        action: 'READ',
    },
    {
        path: 'articles/new',
        name: 'Add article',
        component: AddArticle,
        action: 'WRITE',
    },
]
